export const ANIMATION_DURATION = {
  mount: 300,
  unmount: 250,
};
